import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import {
  ZeeFontBold,
  ZeeFontMedium,
  ZeeFontRegular,
  getCommerceIcons
} from 'src/styles/font';
import { flex } from 'src/styles/utils';
import { CommerceIconsSet } from 'src/utils/constants/IconsConstants';

import { MediaBP as MQ } from '../../../styles/mediaQuery';

export const cardContainer = (onPlayer = false) => css`
  height: fit-content;
  width: 100%;
  display: flex;
  gap: 8px;
  ${MQ.MediaMd} {
    gap: 12px;
    width: ${onPlayer ? '100' : '46'}%;
  }
  ${MQ.MediaLg} {
    width: 100%;
  }
`;

export const FigureWrapper = styled.figure`
  & img {
    width: 96px;
    height: 96px;
    border-radius: 8px;
    ${MQ.MediaSmPortrait} {
      width: 112px;
      height: 112px;
    }
    ${MQ.MediaMd} {
      width: 136px;
      height: 136px;
    }
  }
`;

export const iconStyling = (wishlisted = false) => css`
  cursor: pointer;
  width: 20px;
  height: 20px;
  ${ZeeFontRegular(20, 20)};
  color: ${colors.PrimaryWhiteColor};
  ${getCommerceIcons(
    wishlisted ? CommerceIconsSet.WISHLISTED : CommerceIconsSet.WISHLIST
  )};
  ${MQ.MediaSmPortrait} {
    width: 24px;
    height: 24px;
    ${ZeeFontRegular(24, 24)};
  }
  ${MQ.MediaMd} {
    width: 24px;
    height: 24px;
    ${ZeeFontRegular(24, 24)};
  }
  ${MQ.MediaLg} {
    width: 28px;
    height: 28px;
    ${ZeeFontRegular(28, 28)};
  }
`;

export const descriptionWrapper = (onPlayer = false) => css`
  ${flex('row', '', 'flex-start')}
  gap: 1px;
  width: 100%;
  height: 100%;
  ${MQ.MediaMd} {
    ${onPlayer ? 'padding: 10px 0' : ''};
  }
`;

export const descriptionStyling = (onPlayer = false) => css`
  ${flex('column', '', 'flex-start')}
  gap: 4px;
  width: 100%;
  ${MQ.MediaSmPortrait} {
    gap: 6px;
  }
  ${MQ.MediaMd} {
    gap: ${onPlayer ? '12' : '4'}px;
  }
  ${MQ.MediaLg} {
    gap: ${onPlayer ? '12' : '6'}px;
  }
  ${MQ.MediaXl} {
    gap: ${onPlayer ? '16' : '6'}px;
  }
`;

export const textContainer = (onPlayer = false) => css`
  ${flex('column', '', 'flex-start')}
  gap: 4px;
  ${MQ.MediaMd} {
    gap: 6px;
  }
  ${MQ.MediaLg} {
    gap: ${onPlayer ? '8' : '4'}px;
  }
  ${MQ.MediaXl} {
    gap: ${onPlayer ? '12' : '4'}px;
  }
`;

export const title = (onPlayer = false) => css`
  color: ${colors.TintedNeutral};
  ${ZeeFontMedium(11, 16)};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: ${onPlayer ? '14' : '52'}vw;
  ${MQ.MediaSmPortrait} {
    width: 60vw;
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaMd} {
    width: ${onPlayer ? '14' : '22'}vw;
    ${ZeeFontMedium(16, 22)};
  }
  ${MQ.MediaLg} {
    width: 16vw;
  }
`;

export const text = (onPlayer = false) => css`
  color: ${colors.PrimaryWhiteColor};
  overflow: hidden;
  ${onPlayer
    ? `display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;`
    : `white-space: nowrap;
    text-overflow: ellipsis;`}
  width: ${onPlayer ? '14' : '52'}vw;
  ${ZeeFontRegular(12, 18)};
  ${MQ.MediaSmPortrait} {
    width: 60vw;
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaMd} {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    width: ${onPlayer ? '14' : '22'}vw;
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaLg} {
    width: 16vw;
  }
`;

export const PriceDetailsWrapper = styled.div`
  ${flex('row', '', 'flex-end')}
  gap: 8px;
`;

export const DiscountedPrice = styled.span`
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(12, 18)};
  ${MQ.MediaSmPortrait} {
    ${ZeeFontBold(16, 22)};
  }
  ${MQ.MediaMd} {
    ${ZeeFontBold(14, 22)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontBold(16, 22)};
  }
`;

export const OriginalPrice = styled.span`
  color: ${colors.DarkGrayColor};
  text-decoration: line-through;
  ${ZeeFontMedium(10, 18)};
  ${MQ.MediaSmPortrait} {
    ${ZeeFontMedium(12, 18)};
  }
  ${MQ.MediaMd} {
    ${ZeeFontMedium(12, 18)};
  }
`;

export const buyNow = css`
  height: 32px;
  text-align: left;
  background: transparent;
  color: ${colors.Lavender};
  ${ZeeFontBold(12, 18)};
  ${MQ.MediaSmPortrait} {
    height: 38px;
    ${ZeeFontBold(14, 20)};
  }
  ${MQ.MediaLg} {
    height: 38px;
    ${ZeeFontBold(14, 20)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontBold(14, 20)};
  }
  transition: background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
`;
